import axios from 'axios';
import { baseURL } from '../config/config.js';

let instance = axios.create({
  baseURL: baseURL,
  timeout: 120000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor
instance.interceptors.request.use(
  async config => {
    return config;
  },
  error => {
    console.log('Request Error:', error);
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      // Log the entire error response for debugging
      console.log('Response Error:', error.response.data);

      // Check if the error has a nested error object
      const serverError = error.response.data;

      // Handle Mongoose validation errors
      if (serverError.error && serverError.error.name === 'ValidationError') {
        const validationErrors = serverError.error.errors;

        // Extract specific error message if it exists
        if (validationErrors && validationErrors.phone_number) {
          return Promise.reject({
            message: validationErrors.phone_number.message,
            field: 'phone_number',
          });
        }
      }

      // If a general message is provided, use it
      if (serverError.message) {
        return Promise.reject({ message: serverError.message });
      }

      // Fallback for other types of errors
      return Promise.reject({ message: 'An unexpected error occurred' });
    } else if (error.request) {
      console.log('No Response:', error.request);
      return Promise.reject({ message: 'No response from server' });
    } else {
      console.log('Error:', error.message);
      return Promise.reject({ message: error.message });
    }
    // if (error.response) {
    //   // Log the actual error message from the backend
    //   console.log('Response Error:', error.response.data);
    //   return Promise.reject(error.response.data);
    // } else if (error.request) {
    //   // The request was made, but no response was received
    //   console.log('No Response:', error.request);
    //   return Promise.reject({ message: 'No response from server' });
    // } else {
    //   // Something else happened in setting up the request
    //   console.log('Error:', error.message);
    //   return Promise.reject({ message: error.message });
    // }
  }
);

export default instance;
